import { ErrandInterface } from './errand.model';
import { ErrandType } from './errand-type.enum';

export class FlyToChapterErrandModel implements ErrandInterface {
    type = ErrandType.flyToChapter;
    value = null;

    constructor() { }
}
